//INDEX BANNER SLIDER

const bannerSliderElm = document.querySelector('.new_landing_index_wpr .splide');
if(bannerSliderElm){
    const bannerSlider = new Splide( bannerSliderElm, {
        type   : 'slide',
        arrows : false,
        pagination: true
    });

bannerSlider.mount();
}


  const defaultOptions = {
    type: "loop",
    perPage: 3,
    perMove: 1,
    // gap: "3rem",
    autoplay: true,
    pauseOnHover: true,
    arrows: false, 
    pagination: false,
    breakpoints: {
      768: { perPage: 2 },
      480: { perPage: 1 },
    },
  };

  document.querySelectorAll(".certifications-testimonials-slider").forEach((sliderEl) => {
    const splide = new Splide(sliderEl, defaultOptions).mount();
    const wrapper = sliderEl.closest(".our-certifications-testimonials") || sliderEl.parentElement;
    const prevButton = wrapper ? wrapper.querySelector(".splide-prev") : null;
    const nextButton = wrapper ? wrapper.querySelector(".splide-next") : null;

    if (prevButton) prevButton.addEventListener("click", () => splide.go('<'));
    if (nextButton) nextButton.addEventListener("click", () => splide.go('>'));

    sliderEl.splideInstance = splide;
  });






  const landing_video_wrapper = document.querySelector(".landing_about_wpr .vdp_wpr");
  if (landing_video_wrapper){
      const btn = landing_video_wrapper.querySelector(".video_cntrl_btn");
  const video = landing_video_wrapper.querySelector("video");

  btn.addEventListener("click", () => {
    btn.style.display = "none"; 
    video.play();              
  });
  }



  document.querySelectorAll(".scrl_opt").forEach((btn) => {

    btn.addEventListener("click", function () {
      // find parent section
      const parentSection = btn.closest("section");

      // find the next section
      const nextSection = parentSection.nextElementSibling;

      if (nextSection) {
        nextSection.scrollIntoView({
          behavior: "smooth",
        });
      }
    });

  });



  function initfeaturedInSlider() {
    const featuredInElm = document.querySelector('#featured-in-slider');
    if (!featuredInElm) return;

    const isDesignMode = featuredInElm.dataset.isdesignmode === 'true';

    const initSplide = () => {
      if (featuredInElm.splide) featuredInElm.splide.destroy(true);

      const splide = new Splide(featuredInElm, {
        type: 'loop',
        arrows: false,
        center: true,
        autoplay: true,
        interval: 1000,
        speed: 2000,
        pagination: false,
        perMove : 1,
        perPage: 5,
         padding: { left: '50px', right: '50px' } ,
         breakpoints: {
          1284: { perPage: 4 },
          989: { perPage: 3 },
          768: { perPage: 2 ,
            padding: { left: '50px', right: '50px' } 
          },
          600: { perPage: 1 ,
            padding: { left: '30px', right: '30px' } ,
            gap: '20px',

          },
        },
        gap: '30px',
      });

      splide.mount();
      featuredInElm.splide = splide;

      console.log(' Featured In Splide initialized');
    };

    initSplide();
  }

  document.addEventListener('DOMContentLoaded', initfeaturedInSlider);
  document.addEventListener('shopify:section:load', initfeaturedInSlider);
  document.addEventListener('shopify:block:select', initfeaturedInSlider);